export class NewUserDocumentProcessTo {
    
    firstName: string;
    lastName: string;
    Email: string;
    sintraId: string;
}